import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, CanMatchFn, Router } from "@angular/router";
import { CommonService } from "../shared/common.service";

export const authGuard: CanMatchFn | CanActivateFn | CanActivateChildFn = () => {
    const commonService = inject(CommonService)
    const router = inject(Router)

    if (commonService.getUser()) {
        return true
    }

    return router.parseUrl("/login")
}